<section>
    <nav>
        <ul>
            <a class="summary active" (click)="toggleActive('summary'); closeHelp()" routerLink="/summary"><li><img src="assets/img/navbar/Summary.png" alt=""><p>Summary</p></li></a>
            <a class="task" (click)="toggleActive('task');closeHelp()" routerLink="/task"><li><img src="assets/img/navbar/Add task.png" alt=""><p>Add Task</p></li></a>
            <a class="board" (click)="toggleActive('board');closeHelp()" routerLink="/board"><li><img src="assets/img/navbar/Board.png" alt=""><p>Board</p></li></a>
            <a class="contacts" (click)="toggleActive('contacts');closeHelp()" routerLink="/contacts"><li><img src="assets/img/navbar/Contacts.png" alt=""><p>Contacts</p></li></a>
        </ul>
    </nav>
</section>